<template>
    <div class="p-menuitem-link">
        <span :class="['p-menuitem-icon', 'pi', item.icon]"> </span>
        <span class="p-menuitem-text">{{ label }} </span>
    </div>
    <Divider class="my-2"/>
</template>

<script>
import { getAttributeInputType } from '@/helpers/enum-helpers';
export default {
    name: 'FormAttribute',
    data() {
        return {
            label: null,
        };
    },
    props: {
        item: {
            type: Object,
        },
    },
    created() {
        this.setLabel();
    },
    methods: {
        setLabel() {
            if (!this.item.label) {
                this.label = getAttributeInputType(parseInt(this.item.type));
            } else {
                this.label = `${this.item.label} (${this.item.code})`;
            }
        },
    },
};
</script>
